import { useEffect } from "react";

export default function useSmoothScroll() {
  useEffect(() => {
    const handleAnchorClick = (event) => {
      const target = event.target.closest("a[href^='#']");
      if (target) {
        const hash = target.getAttribute("href");
        if (hash.length > 1) {
          const element = document.querySelector(hash);
          if (element) {
            event.preventDefault();
            window.scrollTo({
              top: element.offsetTop - 60,
              behavior: "smooth",
            });
          }
        } else {
          event.preventDefault(); // evita error si es solo '#'
        }
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
}
